import { FC, useMemo } from 'react'
import { NxTextColor, NxTextSize, NxTextWeight } from './types'

type NxTextProps = {
  size?: NxTextSize
  color?: NxTextColor
  weight?: NxTextWeight
  className?: string
  disabled?: boolean
  children: string | undefined | number | (string | undefined | number)[]
}

const NxText: FC<NxTextProps> = ({
  size = 'md',
  color = 'neutral',
  weight = '400',
  className: extraClassName = '',
  disabled = false,
  children,
}): React.ReactElement => {
  const classes: string = useMemo(
    (): string =>
      `${extraClassName} text text--${size} text--${color}--${weight} ${
        disabled ? 'text--disabled' : ''
      }`,
    [extraClassName, color, disabled, size, weight],
  )
  return <p className={classes}>{children}</p>
}

export default NxText
